'use strict';

import { space_type_colors } from '../utils/cn_space_type_color';
import { cn_element_type } from './cn_element_type';


//***********************************************************************************
//***********************************************************************************
//******     CN-Map    **************************************************************
//******     Copyright(C) 2019-2020 EnerBIM                        ******************
//***********************************************************************************
//***********************************************************************************

//***********************************************************************************
//***********************************************************************************
//**** Space type class
//***********************************************************************************
//***********************************************************************************

export class cn_space_type extends cn_element_type {

    constructor(parent) {
        super(parent);
        this.class_name = 'cn_space_type';
        this.space_default_name = ''
        this.space_usage = '';
        this.color = '';
        this.heated = true;
        this.editable = true;
        this.numerotation = 1;
        this.prefix = "";
    }

    //***********************************************************************************
    //**** serialize
    //***********************************************************************************
    serialize() {
        var json = this.serialize_element();
        json.class_name = 'cn_space_type';
        json.name = this.name;
        json.space_default_name = this.space_default_name;
        json.heated = this.heated;
        json.space_usage = this.space_usage;
        json.color = this.color;
        json.editable = this.editable;
        json.numerotation = this.numerotation;
        json.prefix = this.prefix;
        return json;
    }

    static unserialize(json, parent) {
        const result = new cn_space_type(parent);
        result.unserialize_element(json);
        result.name = json.name;
        result.space_default_name = json.space_default_name;
        result.space_usage = json.space_usage;
        result.heated = json.heated;
        result.color = json.color;
        result.editable = json.editable;
        if (typeof(json.numerotation) == 'number')
            result.numerotation = json.numerotation;
        if (typeof(json.prefix) == 'string')
            result.prefix = json.prefix;
        return result;
    }

    static default_heated_space_type(parent) {
        const default_heated_space_type = new cn_space_type(parent);
        default_heated_space_type.name = 'Espace standard';
        default_heated_space_type.heated = true;
        default_heated_space_type.color = '#F4EDDE';
        default_heated_space_type.editable = false;
        return default_heated_space_type;
    }

    static default_not_heated_space_type(parent) {
        const default_not_heated_space_type = new cn_space_type(parent);
        default_not_heated_space_type.name = 'Espace non chauffé';
        default_not_heated_space_type.heated = false;
        default_not_heated_space_type.color = '#9BC1E4';
        return default_not_heated_space_type;
    }

    /**
     *
     * @param {string} name
     * @param {string} code_bim
     * @param {number} color_index
     */
    static build_from_room_type_spec(name, code_bim, color_index, parent) {
        const result = new cn_space_type(parent);
        result.name = name;
        result.space_default_name = name;
        result.space_usage = code_bim;
        result.heated = true;
        result.color = space_type_colors[color_index % space_type_colors.length]
        return result;
    }


}

